import { useRef } from "react";

import { ProductSearchTileRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductTileLayout } from "@/components/Product/ProductTile/productTile.config";
import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import { AutocompleteItem } from "@/components/Search/SearchBar/AutocompleteItem/autocompleteItem.container";
import { BaseItemProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { ProductsSourceType } from "@/components/Search/SearchBar/searchBar.types";
import * as AlgoliaTrackingService from "@/services/algolia/algoliaTracking.service";
import "./products.scss";
import { ProductMapper } from "@omni/mappers/product/product.mapper";
import "./products.scss";
type ProductsItemProps = BaseItemProps<ProductsSourceType>;

const ProductsItem = ({
    item,
    autocompleteState,
    autocompleteActions
}: ProductsItemProps) => {
    const productTileItem =
        ProductMapper.fromAlgoliaSearchAutocompleteToProductTile(item);
    const ref = useRef<HTMLAnchorElement | null>(null);

    const trackClick = () => {
        if (!item.__autocomplete_queryID || !item.__autocomplete_id) return;

        AlgoliaTrackingService.trackQuery(
            item.__autocomplete_queryID,
            item.sku,
            item.__autocomplete_id
        );
    };

    const handleAutocompleteItemSubmit = () => {
        trackClick();
        ref.current?.click();
    };

    return (
        <AutocompleteItem<ProductsSourceType>
            className={
                "productsTemplate__items__item p-2 d-flex flex-column card--all"
            }
            itemId={item.__autocomplete_id}
            onSubmit={handleAutocompleteItemSubmit}
            autocompleteState={autocompleteState}
            autocompleteActions={autocompleteActions}
        >
            <ProductTile
                ref={ref}
                sku={item.sku}
                product={productTileItem}
                allowInstantAddToCart={false}
                productTileConfig={{
                    border: false,
                    amountOfFeatures: 0,
                    imageRenditions: ProductSearchTileRenditions,
                    components: ProductTileLayout.SEARCH()
                }}
                onClickTrack={trackClick}
            />
        </AutocompleteItem>
    );
};

export { ProductsItem };
